import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div>
    <h1>Error 404 - La pagina no existe!</h1>
    <Link to="/">Ir a Inicio</Link>
  </div>
);

export default NotFound;